import { isSameId } from "../../helpers";
export default function (store, ev) {
    const state = store.getState();
    let originalRow;
    const id = ev.id || ev.row?.id;
    const rows = state.rows.map(r => {
        if (isSameId(r.id, id)) {
            originalRow = { ...r };
            if (ev.replace) {
                return { id, ...ev.row };
            }
            return { ...r, ...ev.row };
        }
        return r;
    });
    store.setState({ rows });
    return () => {
        store.in.exec("update-row", {
            row: originalRow,
            replace: true,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=update.js.map